enum TypeSorting {
  NUMBER = 'num',
  ALPHABET = 'title',
  AREA = 'area'
}

export default TypeSorting;
